export const fetchMicrocredentialTypes = (user) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'FETCH_MICROCREDENTIAL_TYPES_REQUEST' });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/solicitudes/tipos`, {
                    method: 'GET',        
                    headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer '+ user.token
                    },
            });
            const requestData = await response.json();
            const filteredData = requestData.filter(type => 
                type.Id.toUpperCase() !== '1E9D87BF-B9FF-4D20-A615-5459BBCD5984'
            );      
          
            dispatch({
                type: 'FETCH_MICROCREDENTIAL_TYPES_SUCCESS',
                payload: filteredData,
            });
        } catch (error) {
            dispatch({
                type: 'FETCH_MICROCREDENTIAL_TYPES_ERROR',
                payload: error.message,
            });
        }
    };
};